import { CustomMessageCard } from "./MessageCard";

const NotFound = (props:any) => {
  return (
    <CustomMessageCard msgData={<div>Oops - we've looked everywhere and could not find this page.</div>}></CustomMessageCard>
  );
}

export default NotFound;
